type Pattern = 'tap' | 'success' | 'error' | 'celebrate';

const PATTERNS: Record<Pattern, number | number[]> = {
  tap: 30,
  success: [60, 30, 60],
  error: [80, 40, 80],
  celebrate: [80, 60, 80, 60, 200],
};

class HapticManagerImpl {
  private enabled = true;

  setEnabled(value: boolean): void {
    this.enabled = value;
  }

  vibrate(pattern: Pattern): void {
    if (!this.enabled) return;
    if (typeof navigator === 'undefined' || typeof navigator.vibrate !== 'function') return;
    try {
      navigator.vibrate(PATTERNS[pattern]);
    } catch {
      // navegadores antigos podem lançar — silenciar
    }
  }
}

export const hapticManager = new HapticManagerImpl();
